<template>
  <div>
    <div class="text-black">
      <BCol
        md="12"
        class="d-flex gap-10 w-100 p-0 my-[24px]"
      >
        <div class="flex rounded-lg items-center border overflow-hidden w-full max-w-[400px] h-[38px]">
          <span
            class="k-search-normal-1 font-bold text-10 align-middle ml-[10px] flex items-center text-[#C2C2C2]"
          />
          <BFormInput
            v-model="keyword"
            placeholder="Cari nama atau email"
            class="border-0"
            @input="handleSearch()"
          />
        </div>
        <BButton
          tag="router-link"
          :to="{
            name: $route.meta.routeCreate,
          }"
          variant="primary"
          class="ml-auto px-3"
        >
          <strong>Tambah</strong>
        </BButton>
      </BCol>
    </div>
    <BOverlay
      id="scroll"
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <div
        id="table"
        style="height: calc(100vh - 340px); overflow-y: scroll;"
        @scroll="handleScroll"
      >
        <BTable
          :items="items"
          :fields="fields"
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          show-empty
        >
          <template #cell(id)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(mou)="data">
            <span
              :class="data.item.mou ? 'text-[#08A0F7] cursor-pointer' : 'text-[#333]'"
              @click="data.item.mou ? toLink(data.item.mou) : false"
            >{{ data.item.mou ? 'Detail' : '-' }}</span>
          </template>
          <template #cell(name)="data">
            <div class="flex items-start flex-col gap-4">
              <div>
                {{ data.item.name }}
              </div>
              <div class="text-muted">
                {{ data.item.no_partner }}
              </div>
            </div>
          </template>
          <template #cell(action)="data">
            <div class="flex justify-center items-center">
              <BButton
                class="btn-icon"
                size="sm"
                variant="flat-warning"
                :to="{
                  name: $route.meta.routeEdit,
                  params: { id: data.item.id }
                }"
                tag="router-link"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/edit.svg"
                  alt="Komerce"
                >
              </BButton>
            </div>
          </template>
        </BTable>
      </div>
    </BOverlay>
    <ModalDelete
      :id-item="idItem"
      @deleted="getListData()"
    />
  </div>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { alertError } from '@toast'
import { tableData } from '../config'
import ModalDelete from '../ModalDelete.vue'

export default {
  components: {
    ModalDelete,
  },
  data() {
    return {
      loading: false,
      items: [],
      limit: 20,
      offset: 0,
      lastData: false,
      keyword: '',
      fields: tableData,
      idItem: 0,
      alertError,
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    handleScroll() {
      const table = document.getElementById('table')
      if ((table.scrollTop >= table.scrollHeight - table.offsetHeight - 5) && !this.loading && !this.lastData) {
        this.getNextData()
      }
    },
    async getListData() {
      this.loading = true
      this.offset = 0
      const params = `offset=${this.offset}&limit=${this.limit}&status=registered&keyword=${this.keyword}`
      const url = `v1/partners?${params}`
      //   const swaggerKomtim =
      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data } = res.data
          this.items = data
          this.offset = data.length

          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
    },
    async getNextData() {
      this.loading = true
      if (!this.lastData) {
        const params = `offset=${this.offset}&limit=${this.limit}&status=registered&keyword=${this.keyword}`
        const url = `v1/partners?${params}`

        await komtimAxiosIns.get(url)
          .then(res => {
            const { data } = res.data
            this.items.push(...data)
            this.offset += data.length
            this.loading = false
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .catch(err => {
            this.alertError(err)
          })
      }
    },
    handleSearch: _.debounce(function search() {
      this.getListData()
    }, 1000),
    resetFilter() {
      this.filterSelected = []
      this.getListData()
    },
    toLink(link) {
      window.open(link, '_blank')
    },
  },

}
</script>
